/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/** Base class for every error this SDK raises. */
public open class FitException(
    message: String,
    cause: Throwable? = null,
) : Exception(message, cause)

/**
 * The bytes on hand are not valid FIT.
 *
 * [FitDecoder.decode] never lets this escape: it collects one into a [FitError]
 * and returns whatever decoded successfully beforehand. It does propagate out of
 * the streaming entry points, where there is no result object to carry it.
 */
public class FitFormatException(
    message: String,
    public val bytePosition: Int = -1,
    cause: Throwable? = null,
) : FitException(if (bytePosition >= 0) "$message (at byte $bytePosition)" else message, cause)

/** A value does not fit the field it was assigned to. */
public class FitFieldException(
    message: String,
    cause: Throwable? = null,
) : FitException(message, cause)
